export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=324d1783"


//////////////////
// WEBPACK FOOTER
// ./src/components/content/index.vue?vue&type=template&id=324d1783
// module id = XaIu
// module chunks = 0